import { AbstractControl } from '@angular/forms'

/**
 * Validates a website URL based on a regex pattern
 * @param control Abstract control
 * @returns error or null
 */
export function ValidateWebsiteUrl(control: AbstractControl) {
  // Allow empty values, required validation will handle this
  if (!control.value) return null

  // Regex pattern for website URLs
  // Supports http://, https://, www., and various domain extensions
  const regex = /^(https?:\/\/)?(www\.)?[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(\.[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*(\.[a-zA-Z]{2,})(\/.*)?$/i

  if (!regex.test(control.value)) return { invalidWebsiteUrl: true }

  return null
}
